import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import { getVehicleVariantImage } from '@components/WhatsappChallanFlow/helper'
import { INPUT_ICON, INPUT_ICON_LOGO } from '@components/MainWidget/FastagWidget/constants'
import { DEFAULT_CAR_MODAL } from './constants'
import styles from './whatsappChallan.module.scss'

interface VehicleInfoHeaderProps {
  regNum: string
  vehicleData: any
  vehicleImage: string
}

const VehicleInfoHeader: React.FC<VehicleInfoHeaderProps> = ({ regNum, vehicleData, vehicleImage }) => {
  const vehicleVaraintImage = getVehicleVariantImage(vehicleImage)

  return (
    <div className={styles.headerVehicleInfo}>
      <div className={styles.vehicleDetails}>
        <p className={styles.vehicleName}>
          {vehicleData?.db_make_name && vehicleData?.db_model_name
            ? `${vehicleData.db_make_name} ${vehicleData.db_model_name}`
            : DEFAULT_CAR_MODAL}
        </p>
        <div className={styles.InputBoxContainer}>
          <Image
            width={24}
            height={28}
            src={`${assetLoader()}${INPUT_ICON}`}
            className={styles.inputIcon}
            alt={INPUT_ICON_LOGO}
          />
          <span id="challanWidgetInput" className={styles.inputField}>
            {regNum}
          </span>
        </div>
      </div>
      <div className={styles.vehicleImage}>
        <Image width={126} height={72} src={vehicleVaraintImage} alt="challan vehicle image" />
      </div>
    </div>
  )
}

export default VehicleInfoHeader
